module.exports = __webpack_public_path__ + "static/media/surveying-river-crossing.d808c439.jpg";